module.exports = __webpack_public_path__ + "static/media/Icn-odp.93e51312.svg";